import React from 'react'
import { Paper, Box, Divider, Typography } from '@mui/material';



const ProjectCount = ({ project }) => {

    return (
        <Paper sx={{
            display: 'flex', justifyContent: 'flex-start',
            alignItems: "center",
            p: 1,
            mx:1,
            borderRadius: 1
        }}>

            <Box>
                <Typography variant="subtitle2">{project?.title}</Typography>
            </Box>
            <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            <Box><Typography variant="subtitle2" color="text.secondary">{project?.count} 건</Typography></Box>
        </Paper>
    )
}

export default ProjectCount